"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventDetailsLayout = exports.EventDetailsLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var main_aside_1 = require("../elements/main-aside");
var entity_list_section_1 = require("./entity-list-section");
var content_node_1 = require("./content-node");
var content_section_1 = require("../elements/content-section");
var entity_value_1 = require("./entity-value");
var entity_row_1 = require("./entity-row");
var lodash_1 = require("lodash");
var format_date_string_1 = require("../../utils/format-date-string");
var use_lang_1 = require("../../hooks/use-lang");
var badge_divider_1 = require("../elements/badge-divider");
var time_display_1 = require("../elements/time-display");
var grid_1 = require("../elements/grid");
var entity_link_value_1 = require("./entity-link-value");
var file_asset_value_1 = require("./file-asset-value");
var utils_1 = require("../../utils");
exports.EventDetailsLayoutDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MainAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContentNodeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n\n    &:first-child {\n      padding-top: 0;\n    }\n  "], ["\n    padding: ", " 0 ", ";\n\n    &:first-child {\n      padding-top: 0;\n    }\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(4))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    margin-top: ", ";\n  "], ["\n    ", ";\n    margin-top: ", ";\n  "])), ContentNodeStyles, theme_1.theme.UNIT(4))
});
var SessionDescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n    padding-left: 1px;\n    font-size: ", ";\n\n    a {\n      font-size: ", ";\n    }\n\n    p {\n      margin-bottom: 0.65em;\n    }\n  "], ["\n    margin-top: ", ";\n    padding-left: 1px;\n    font-size: ", ";\n\n    a {\n      font-size: ", ";\n    }\n\n    p {\n      margin-bottom: 0.65em;\n    }\n  "])), theme_1.theme.UNIT(4), theme_1.theme.FONT_SIZE(14), theme_1.theme.FONT_SIZE(14))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ListSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var RowStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin-top: ", ";\n    width: 100%;\n    margin-bottom: ", ";\n    padding: ", " ", " ", " ", ";\n    ", ";\n\n    &:last-child {\n      background: none;\n    }\n  "], ["\n    margin-top: ", ";\n    width: 100%;\n    margin-bottom: ", ";\n    padding: ", " ", " ", " ", ";\n    ", ";\n\n    &:last-child {\n      background: none;\n    }\n  "])), theme_1.theme.UNIT(2), theme_1.theme.UNIT(4), theme_1.theme.UNIT(1), theme_1.theme.UNIT(1), theme_1.theme.UNIT(7.5), theme_1.theme.UNIT(1), theme_1.theme.H_DOT_BG_END())
});
var SessionGroupStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var DateDividerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    font-size: ", ";\n  \n    .shp-badge-divider__badge {\n      background-color: #f9f9f9;\n    }\n  "], ["\n    font-size: ", ";\n  \n    .shp-badge-divider__badge {\n      background-color: #f9f9f9;\n    }\n  "])), theme_1.theme.FONT_SIZE(14))
});
var TimeDisplayStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    margin: ", ";\n  "], ["\n    margin: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var TimesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    margin-left: -2px;\n    box-sizing: border-box;\n    opacity: 0.9;\n    padding: ", " 0 ", " ", "; \n    border: 1px dotted ", ";\n    background: #FCFCFC;\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    margin-left: -2px;\n    box-sizing: border-box;\n    opacity: 0.9;\n    padding: ", " 0 ", " ", "; \n    border: 1px dotted ", ";\n    background: #FCFCFC;\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(1), theme_1.theme.UNIT(3), theme_1.theme.UNIT(0, 2), theme_1.theme.UNIT(4), theme_1.theme.COLOR('line-mid'))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled_components_1.default.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles),
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  LinkValue: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Row: (0, styled_components_1.default)(entity_row_1.EntityRow)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), RowStyles),
  SessionGroup: styled_components_1.default.div(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), SessionGroupStyles),
  DateDivider: (0, styled_components_1.default)(badge_divider_1.BadgeDivider)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), DateDividerStyles),
  SessionDescription: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), SessionDescriptionStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Controls: styled_components_1.default.div(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  Times: styled_components_1.default.div(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), TimesStyles),
  TimeDisplay: (0, styled_components_1.default)(time_display_1.TimeDisplay)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), TimeDisplayStyles)
};
var EventDetailsLayout = function (props) {
  var className = props.className,
    entity = props.entity,
    banner = props.banner,
    asideHeader = props.asideHeader,
    asideFooter = props.asideFooter,
    mainHeader = props.mainHeader,
    mainFooter = props.mainFooter;
  var _a = entity.sessions,
    sessions = _a === void 0 ? [] : _a,
    _b = entity.files,
    files = _b === void 0 ? [] : _b,
    venue = entity.venue,
    description = entity.description,
    overview = entity.overview,
    sessionInfo = entity.sessionInfo;
  var hasVenue = !!venue;
  var hasSessions = !!sessions.length;
  var hasAside = asideHeader || asideFooter;
  var t = (0, use_lang_1.useLang)();
  return react_1.default.createElement(My.Container, {
    className: className
  }, banner, react_1.default.createElement(My.MainAside, {
    main: react_1.default.createElement(My.Main, null, mainHeader, react_1.default.createElement(My.Section, null, react_1.default.createElement(My.Description, {
      entity: description,
      title: 'About:'
    }), react_1.default.createElement(My.Description, {
      entity: overview,
      title: 'Overview:'
    }), react_1.default.createElement(My.Description, {
      entity: sessionInfo,
      title: 'Session Information:'
    }), hasVenue && react_1.default.createElement(My.Value, {
      entity: venue
    })), react_1.default.createElement(My.ListSection, {
      variant: 'large',
      rowComponent: file_asset_value_1.FileAssetValue,
      showDividers: true,
      title: "Related Files:",
      items: files,
      maxItems: 3
    }), hasSessions && (0, utils_1.currentUserCanRead)('Session') && react_1.default.createElement(My.Section, {
      title: "{{SESSIONS}}:"
    }, (0, lodash_1.map)((0, lodash_1.groupBy)(sessions, function (session) {
      return (0, format_date_string_1.formatDateString)(session.startDate, 'dddd, Do MMM YYYY');
    }), function (sessions, date) {
      return react_1.default.createElement(My.SessionGroup, {
        key: date
      }, react_1.default.createElement(My.DateDivider, null, date || t('No Date Assigned')), (0, lodash_1.sortBy)(sessions, 'startDate').map(function (session) {
        var _a = session.presenters,
          presenters = _a === void 0 ? [] : _a,
          _b = session.colors,
          colors = _b === void 0 ? [] : _b,
          _c = session.groups,
          groups = _c === void 0 ? [] : _c,
          venue = session.venue,
          room = session.room;
        var gridItems = (0, lodash_1.filter)(__spreadArray(__spreadArray(__spreadArray([], __read(presenters.map(function (presenter) {
          return react_1.default.createElement(My.LinkValue, {
            label: "Presenter",
            variant: 'card',
            key: presenter.id,
            entity: presenter
          });
        })), false), __read(colors.map(function (color) {
          return react_1.default.createElement(My.Value, {
            variant: 'card',
            key: color.id,
            entity: color
          });
        })), false), __read(groups.map(function (group) {
          return react_1.default.createElement(My.Value, {
            label: "Group",
            variant: 'card',
            key: group.id,
            entity: group
          });
        })), false));
        var label = "Session ".concat(room ? " \u2013 ".concat(room.shortName || room.name) : '');
        return react_1.default.createElement(My.Row, {
          key: session.id,
          showMenu: true,
          entity: session,
          showLabel: !!label,
          label: label,
          controls: react_1.default.createElement(My.Controls, null, react_1.default.createElement(My.Times, null, react_1.default.createElement(My.TimeDisplay, {
            date: session.startDate
          }), session.endDate && ' – ', react_1.default.createElement(My.TimeDisplay, {
            date: session.endDate
          })))
        }, react_1.default.createElement(My.SessionDescription, {
          entity: session.description
        }), !!gridItems.length && react_1.default.createElement(My.Grid, {
          spacing: 3,
          items: gridItems
        }));
      }));
    })), mainFooter),
    aside: hasAside && react_1.default.createElement(My.Aside, null, asideHeader, asideFooter)
  }));
};
exports.EventDetailsLayout = EventDetailsLayout;
exports.EventDetailsLayout.defaultProps = exports.EventDetailsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35;